import { useLanguage } from "@/iti-core-react/hooks/useLanguage";
import { useEffect, useState } from "react";
import { imgSrcLogoWhisephere } from "../LoginForm.utils";
import("./WelcomeSign.scss");

export default function WelcomeSign() {
	const { t } = useLanguage();
	const [isDark, setIsDark] = useState(() => {
		const savedMode = localStorage.getItem("darkMode");
		return savedMode === "true";
	});

	useEffect(() => {
		const observer = new MutationObserver(() => {
			const darkModeActive =
				document.documentElement.getAttribute("data-theme") === "dark";
			setIsDark(darkModeActive);
		});

		observer.observe(document.documentElement, {
			attributes: true,
			attributeFilter: ["data-theme"],
		});

		return () => observer.disconnect();
	}, []);

	const logoSrc = isDark
		? `${import.meta.env.VITE_PUBLIC_PATH}assets/logo-wisephere-white.svg`
		: imgSrcLogoWhisephere;

	return (
		<div className="row welcome-sign-container">
			<img className="whisephere-logo" src={logoSrc} alt="Wisephere" />

			<div className="row welcome-texts">
				<div>{t("login.title-app-1")}</div>
				<div>
					<span>{t("login.title-app-2")}</span>
					<span className="gradient-text">{t("login.title-app-3")}</span>
				</div>
			</div>
		</div>
	);
}
